import React, { memo } from 'react';
import { Col, Row, Typography } from 'components';

interface IFileUpload {
  title?: string;
  message?: string;
}

export const UploadContent = memo<IFileUpload>((props) => {
  const { title, message } = props;
  return (
    <Row>
      <Col span={24}>
        <Typography.Text style={{ fontSize: 14, fontWeight: 500, color: '#05796B' }} underline>
          {title || 'Upload File'}
        </Typography.Text>
      </Col>
      <Col span={24}>
        <Col style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: '10px' }}>
          <Typography.Text className={'font-size-10'} style={{ color: '#68686B' }}>
            {message || 'Max size: 5MB'}
          </Typography.Text>
        </Col>
      </Col>
    </Row>
  );
});
